import { render, staticRenderFns } from "./applyMy3.vue?vue&type=template&id=236519c9&scoped=true&"
import script from "./applyMy3.vue?vue&type=script&lang=js&"
export * from "./applyMy3.vue?vue&type=script&lang=js&"
import style0 from "./applyMy3.vue?vue&type=style&index=0&id=236519c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236519c9",
  null
  
)

export default component.exports